import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { formatPrice } from "@/lib/format";
import { Plus, Package, ShoppingBag, DollarSign } from "lucide-react";

export default function AdminHome() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);
  return (
    <div className="p-5 sm:p-8 lg:p-12" data-testid="admin-dashboard">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-neutral-500">Overview</div>
          <h1 className="editorial font-serif-display text-3xl sm:text-4xl mt-2">Dashboard</h1>
        </div>
        <Link to="/admin/products/new" className="pill-btn h-11 px-5 rounded-full bg-black text-white text-sm hover:bg-neutral-800 inline-flex items-center gap-2" data-testid="dash-new-product-btn">
          <Plus className="h-4 w-4" /> New product
        </Link>
      </div>
      <div className="mt-8 sm:mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
        <StatCard icon={<Package className="h-5 w-5" />} label="Products" value={stats?.products ?? "—"} testid="stat-products" />
        <StatCard icon={<ShoppingBag className="h-5 w-5" />} label="Orders" value={stats?.orders ?? "—"} testid="stat-orders" />
        <StatCard icon={<ShoppingBag className="h-5 w-5" />} label="Paid orders" value={stats?.paid_orders ?? "—"} testid="stat-paid" />
        <StatCard icon={<DollarSign className="h-5 w-5" />} label="Revenue" value={stats ? formatPrice(stats.revenue_usd) : "—"} testid="stat-revenue" />
      </div>

      <div className="mt-10 sm:mt-14">
        <h2 className="font-serif-display text-xl sm:text-2xl">Quick start</h2>
        <ol className="mt-4 space-y-2 text-neutral-700 text-sm list-decimal pl-5">
          <li>Add your first product — upload an image, a downloadable file, and a price.</li>
          <li>Share your store link with early customers.</li>
          <li>When a sale happens, you'll see the order here and the buyer gets an instant email with their download links.</li>
        </ol>
      </div>
    </div>
  );
}

function StatCard({ icon, label, value, testid }) {
  return (
    <div className="bg-white border border-black/10 rounded-sm p-4 sm:p-5" data-testid={testid}>
      <div className="flex items-center gap-2 text-neutral-500 text-[11px] sm:text-xs uppercase tracking-widest">
        {icon}
        <span className="truncate">{label}</span>
      </div>
      <div className="font-serif-display text-2xl sm:text-3xl mt-2 sm:mt-3 break-words">{value}</div>
    </div>
  );
}
